// src/components/calendrier.js
import React, { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import frLocale from '@fullcalendar/core/locales/fr';
import Sidebar from './composant_reutilisable/sidebar';
import Navbar from './composant_reutilisable/navbar';
import { FaArrowLeft, FaArrowRight, FaCalendarAlt, FaEdit, FaTimes } from 'react-icons/fa';
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'



const Calendrier = () => {
    // useAuth();

    // ============================================
    // ÉTAT (STATES)
    // ============================================
    const [currentDate, setCurrentDate] = useState(new Date());
    const [calendarDays, setCalendarDays] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [dayBookings, setDayBookings] = useState([]);
    const [loading, setLoading] = useState(false);

    // Données principales
    const [bookings, setBookings] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [totalRooms, setTotalRooms] = useState(0);

    // États du formulaire
    const [showBookingForm, setShowBookingForm] = useState(false);
    const [showExtensionModal, setShowExtensionModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedBooking, setSelectedBooking] = useState(null);
    // const [bookingError, setBookingError] = useState('');
    const [selectedDateInfo, setSelectedDateInfo] = useState(null);

    // Filtres et pagination
    const [searchTerm, setSearchTerm] = useState('');
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [currentPage, setCurrentPage] = useState(1);

    // Alertes
    // const [showAlert, setShowAlert] = useState({ show: false, message: '', type: '' });

    const [alert, setAlert] = useState({ message: '', type: '' });
    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        // setTimeout(() => {
        //     setAlert({ message: '', type: '' });
        // }, 5000);
    };
    const fermerNotif = () => {
        setAlert({ message: '', type: '' });
        // setAlertModal({ message: '', type: '' });
    };

    // Formulaire de réservation
    const [nouvelleReservation, setNouvelleReservation] = useState({
        nom_client: '',
        prenom_client: '',
        telephone_client: '',
        email_client: '',
        date_debut: '',
        date_fin: '',
        personnes: 1,
    });


    // ============================================
    // FONCTIONS UTILITAIRES
    // ============================================

    // const showAlertMessage = (message, type = 'success') => {
    //     setShowAlert({ show: true, message, type });
    //     setTimeout(() => {
    //         setShowAlert({ show: false, message: '', type: '' });
    //     }, 4000);
    // };

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    };

    // ============================================
    // APPELS API (correspondent à tes endpoints)
    // ============================================

    // Récupérer toutes les réservations (GET /listes-reservation/)
    const fetchBookings = async () => {
        setLoading(true);
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/listes-reservation/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (response.ok) {
                const data = await response.json();
                // La réponse de ListeReservations a la structure : { success, data, pagination, ... }
                const bookingsData = data.data || [];
                setBookings(bookingsData);
            } else {
                console.error('Erreur lors du chargement des réservations');
                showAlert('Erreur lors du chargement des réservations', 'danger');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur réseau - Vérifiez le serveur', 'danger');
        } finally {
            setLoading(false);
        }
    };

    // Récupérer toutes les chambres (GET /listes-chambre/)
    const fetchRooms = async () => {

        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/listes-chambre/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
            });

            if (response.ok) {
                const data = await response.json();
                const roomsData = data.data || data || [];
                setRooms(roomsData);
                setTotalRooms(roomsData.length);
            } else {
                console.error('Erreur lors du chargement des chambres');
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
        }
    };

    // Créer une réservation (POST /reservation-client/)
    const createBooking = async (bookingData) => {
        setLoading(true);

        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/reservation-client/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(bookingData),
            });

            const data = await response.json();
            if (response.ok) {
                showAlert('Réservation créée avec succès !');
                setTimeout(() => {
                    setAlert({ message: '', type: '' });
                }, 2000);
                await fetchBookings();
                await fetchRooms();
                handleCloseModal();
                return { success: true, data: data.reservation || data };
            } else {
                const errorMessage = data.error || 'Erreur lors de la création';
                showAlert(errorMessage, 'danger');
                return { success: false, error: errorMessage };
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur réseau', 'danger');
            return { success: false, error: 'Erreur réseau' };
        } finally {
            setLoading(false);
        }
    };

    const handleOpenUpdateModal = (bookingId) => {
        setSelectedBooking(bookingId);
        setShowExtensionModal(true);
    };

    // Modifier une réservation (POST /modifier-reservation-client/<id>/)
    const updateBooking = async () => {

        if (!selectedBooking) {
            showAlert('Aucune réservation sélectionnée', 'danger');
            return;
        }

        if (!selectedBooking.date_debut || !selectedBooking.date_fin) {
            showAlert('Veuillez remplir toutes les dates', 'danger');
            return;
        }

        if (new Date(selectedBooking.date_debut) >= new Date(selectedBooking.date_fin)) {
            showAlert('La date de départ doit être après la date d\'arrivée', 'danger');
            return;
        }

        const updateData = {
            nom_client: selectedBooking.nom_client,
            prenom_client: selectedBooking.prenom_client,
            telephone_client: selectedBooking.telephone_client,
            email_client: selectedBooking.email_client || '',
        };

        updateData.date_debut = new Date(selectedBooking.date_debut).toISOString();
        updateData.date_fin = new Date(selectedBooking.date_fin).toISOString();

        setLoading(true);
        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/modifier-reservation-client/${selectedBooking.id}/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(updateData),
            });

            const data = await response.json();
            if (response.ok) {
                showAlert('Réservation modifiée avec succès !');
                setTimeout(() => {
                    setAlert({ message: '', type: '' });
                }, 2000);
                await fetchBookings();
                await fetchRooms();
                setShowExtensionModal(false);
                return { success: true, data: data.reservation || data };
            } else {
                const errorData = await response.json().catch(() => ({}));
                const errorMessage = errorData.error || 'Erreur lors de la modification';
                showAlert(errorMessage, 'danger');
                return { success: false, error: errorMessage };
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur réseau', 'danger');
            return { success: false, error: 'Erreur réseau' };
        } finally {
            setLoading(false);
        }
    };

    const handleShowDeleteModal = (bookingId) => {
        setSelectedBooking(bookingId);
        setShowDeleteModal(true);
    };

    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
    };

    // Annuler une réservation (POST /annuler-reservation-client/<id>/)
    const handleAnnulerBooking = async (bookingId, motif = 'Annulation par le client') => {
        setLoading(true);

        const token = localStorage.getItem('access_token');
        try {
            const response = await fetch(`${process.env.REACT_APP_HOTE}/annuler-reservation-client/${bookingId}/`, {
                method: 'POST',  // POST selon ton endpoint
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({ motif }),
            });

            const data = await response.json();
            if (response.ok) {
                showAlert('Réservation annulée avec succès !');
                setTimeout(() => {
                    setAlert({ message: '', type: '' });
                }, 2000);
                await fetchBookings();
                await fetchRooms();
                handleCloseDeleteModal();
                return { success: true, data: data.reservation || data };
            } else {
                const errorData = await response.json().catch(() => ({}));
                const errorMessage = errorData.error || 'Erreur lors de l\'annulation';
                showAlert(errorMessage, 'danger');
                return { success: false, error: errorMessage };
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            showAlert('Erreur réseau', 'danger');
            return { success: false, error: 'Erreur réseau' };
        } finally {
            setLoading(false);
        }
    };

    // ============================================
    // CHARGEMENT INITIAL
    // ============================================

    useEffect(() => {
        const loadData = async () => {
            await fetchRooms();
            await fetchBookings();
        };
        loadData();
    }, []);

    useEffect(() => {
        generateCalendar();
    }, [bookings, currentDate]);

    // ============================================
    // FONCTIONS DE LOGIQUE
    // ============================================

    const isPastDate = (dateStr) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const date = new Date(dateStr);
        date.setHours(0, 0, 0, 0);
        return date < today;
    };

    const isRoomAvailable = (roomId, checkIn, checkOut, excludeBookingId = null) => {
        const overlapping = bookings.filter(booking => {
            if (excludeBookingId && booking.id === excludeBookingId) return false;
            // if (booking.statut === 'termine') return false;
            // if (booking.statut === 'annule') return false;

            const bookingCheckIn = new Date(booking.date_debut);
            const bookingCheckOut = new Date(booking.date_fin);
            const newCheckIn = new Date(checkIn);
            const newCheckOut = new Date(checkOut);

            return booking.chambre?.id === roomId &&
                newCheckIn < bookingCheckOut &&
                newCheckOut > bookingCheckIn;
        });

        return overlapping.length === 0;
    };

    const findAvailableRoom = (checkIn, checkOut, excludeBookingId = null) => {
        for (const room of rooms) {
            if (isRoomAvailable(room.id, checkIn, checkOut, excludeBookingId)) {
                return room;
            }
        }
        return null;
    };

    const getAvailableRooms = (checkIn, checkOut, excludeBookingId = null) => {
        return rooms.filter(room =>
            isRoomAvailable(room.id, checkIn, checkOut, excludeBookingId)
        );
    };

    const generateCalendar = () => {
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth();

        const firstDay = new Date(year, month, 1);
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        let firstDayOfWeek = firstDay.getDay();
        firstDayOfWeek = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;

        const days = [];

        for (let i = 0; i < firstDayOfWeek; i++) {
            days.push(null);
        }

        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(year, month, day);
            const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;

            const dayBookingsForDate = bookings.filter(booking => {
                const checkIn = new Date(booking.date_debut);
                const checkOut = new Date(booking.date_fin);
                const currentDateObj = new Date(dateStr);
                // return currentDateObj >= checkIn && currentDateObj < checkOut &&
                //     booking.statut !== 'termine' &&
                //     booking.statut !== 'annule';
            });

            const nextDay = new Date(dateStr);
            nextDay.setDate(nextDay.getDate() + 1);
            const nextDayStr = nextDay.toISOString().split('T')[0];
            const availableRoomsCount = getAvailableRooms(dateStr, nextDayStr).length;

            days.push({
                date: dateStr,
                day: day,
                isToday: isToday(date),
                isPast: isPastDate(dateStr),
                occupied: dayBookingsForDate.length,
                available: availableRoomsCount,
                totalRooms: totalRooms,
                bookings: dayBookingsForDate,
                isFullyBooked: availableRoomsCount === 0
            });
        }

        setCalendarDays(days);
    };

    const isToday = (date) => {
        const today = new Date();
        return date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear();
    };

    // ============================================
    // GESTION DES ÉVÉNEMENTS FULLCALENDAR
    // ============================================

    const generateCalendarEvents = () => {
        const eventsByDate = {};

        bookings.forEach(booking => {
            const start = new Date(booking.date_debut);
            const end = new Date(booking.date_fin);

            for (let d = new Date(start); d < end; d.setDate(d.getDate() + 1)) {
                const dateStr = d.toISOString().split('T')[0];
                if (!eventsByDate[dateStr]) {
                    eventsByDate[dateStr] = {
                        count: 0,
                        bookings: []
                    };
                }
                eventsByDate[dateStr].count++;
                eventsByDate[dateStr].bookings.push(booking);
            }
        });

        return Object.entries(eventsByDate).map(([date, data]) => ({
            id: date,
            title: data.count > 0 ? String(data.count) : '',
            start: date,
            end: date,
            allDay: true,
            display: 'block',
            backgroundColor: 'transparent',
            borderColor: 'transparent',
            textColor: 'white',
            interactive: false,
            extendedProps: {
                count: data.count,
                bookings: data.bookings,
                date: date,
                isFullyBooked: data.count >= totalRooms
            }
        }));
    };

    const calendarEvents = generateCalendarEvents();

    const renderEventContent = (eventInfo) => {
        if (!eventInfo || !eventInfo.event) return null;

        const count = eventInfo.event.extendedProps?.count || 0;

        if (count === 0) return null;

        let countClass = 'count-low';
        if (count <= 2) countClass = 'count-low';
        else if (count <= 4) countClass = 'count-medium';
        else countClass = 'count-high';

        return (
            <div className="fc--daygrid-day-events">
                <div className="fc-event-badge-bottom">
                    <div className={`count-circle-bottom ${countClass}`}>
                        {count}
                    </div>
                </div>
            </div>
        );
    };

    const handleDateSelect = (info) => {
        const dateStr = info.dateStr;

        // Trouver ou créer les données du jour
        let dayData = calendarDays.find(d => d?.date === dateStr);

        if (!dayData) {
            const date = new Date(dateStr);
            const totalRoomsCount = rooms.length || 0;
            dayData = {
                date: dateStr,
                day: date.getDate(),
                isToday: isToday(date),
                isPast: isPastDate(dateStr),
                occupied: 0,
                available: totalRoomsCount,
                totalRooms: totalRoomsCount,
                bookings: [],
                isFullyBooked: false
            };
        }

        handleDateClick(dayData);
    };

    const handleDateClick = (dayData) => {
        if (!dayData) return;

        // Sélectionner la date
        setSelectedDate(dayData.date);

        // Filtrer les réservations qui COMMENCENT à cette date
        const bookingsForDate = bookings.filter(booking => {
            const checkIn = new Date(booking.date_debut);
            const checkInStr = checkIn.toISOString().split('T')[0];
            return checkInStr === dayData.date;
        });

        setDayBookings(bookingsForDate);
        setShowBookingForm(false);

        if (dayData.isPast) {
            setSelectedDate(dayData.date);
            setDayBookings(dayData.bookings || []);
            setShowBookingForm(false);
            return;
        }

        if (dayData.isFullyBooked) {
            setSelectedDate(dayData.date);
            setDayBookings(dayData.bookings || []);
            setShowBookingForm(false);
            return;
        }

        setSelectedDate(dayData.date);
        setDayBookings(dayData.bookings || []);
        setShowBookingForm(false);
    };

    // ============================================
    // FORMATAGE
    // ============================================

    // const formatDate = (dateStr) => {
    //     if (!dateStr) return '';
    //     const parts = dateStr.split('T')[0].split('-');
    //     return `${parts[2]}/${parts[1]}/${parts[0]}`;
    // };

    const getStatusBadge = (status) => {
        const statusMap = {
            'dispo': { label: 'Disponible', class: 'status-dispo' },
            'encours': { label: 'En cours', class: 'status-encours' },
            'termine': { label: 'Terminé', class: 'status-termine' },
            'reserver': { label: 'Réservé', class: 'status-reserver' },
            'annule': { label: 'Annulée', class: 'status-cancelled' },
        };
        return statusMap[status] || { label: status || 'Inconnu', class: '' };
    };

    // ============================================
    // FILTRAGE ET PAGINATION
    // ============================================


    const getFilteredBookings = () => {
        if (!selectedDate) return [];

        // let filtered = getAllBookings().filter(booking => {
        //     const checkIn = new Date(booking.date_debut);
        //     const checkOut = new Date(booking.date_fin);
        //     const date = new Date(selectedDate);
        //     return date >= checkIn && date < checkOut;
        // });

        let filtered = bookings.filter(booking => {
            if (!booking.date_debut) return false;
            const checkIn = new Date(booking.date_debut);
            const checkOut = new Date(booking.date_fin);
            const checkInStr = checkIn.toISOString().split('T')[0];
            const checkOutStr = checkOut.toISOString().split('T')[0];
            return checkInStr === selectedDate || (selectedDate >= checkInStr && selectedDate < checkOutStr);
        });

        if (searchTerm.trim() !== '') {
            const term = searchTerm.toLowerCase().trim();
            filtered = filtered.filter(booking =>
            (booking.nom_client?.toLowerCase().includes(term) ||
                booking.prenom_client?.toLowerCase().includes(term) ||
                booking.reference?.toLowerCase().includes(term) ||
                booking.chambre?.nom?.toLowerCase().includes(term) ||
                booking.chambre?.reference?.toLowerCase().includes(term))
            );
        }

        return filtered;
    };

    const getPaginatedBookings = () => {
        const filtered = getFilteredBookings();
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return filtered.slice(startIndex, endIndex);
    };

    const getTotalPages = () => {
        const filtered = getFilteredBookings();
        return Math.ceil(filtered.length / itemsPerPage);
    };

    // ============================================
    // GESTIONNAIRES D'ÉVÉNEMENTS
    // ============================================

    // Gestion du formulaire d'ajout
    const handleChange = (e) => {
        const { name, value } = e.target;
        setNouvelleReservation(prev => ({
            ...prev,
            [name]: value
        }));
    };

    useEffect(() => {
        // Initialiser avec "22901" si le champ tel est vide
        if (!nouvelleReservation.telephone_client) {
            setNouvelleReservation(prev => ({ ...prev, telephone_client: "22901" }));
        }
    }, []);

    const handlePhoneChange = (value, country) => {
        // Pour tous les pays, d'abord nettoyer la valeur
        const numericValue = value.replace(/\D/g, '');

        // Si le pays est Bénin (229)
        if (country.dialCode === "229") {
            // Si la valeur est vide ou ne commence pas par 22901, on force le format
            if (!numericValue.startsWith('22901') || numericValue.length < 5) {
                // Garder les chiffres saisis après 229 (max 8 chiffres)
                const userDigits = numericValue.replace(/^229/, '').replace(/^0?/, '').slice(0, 8);
                setNouvelleReservation(prev => ({ ...prev, telephone_client: '22901' + userDigits }));
                return;
            }

            // Limiter à 13 chiffres maximum (22901 + 8 chiffres)
            const limitedValue = numericValue.slice(0, 13);
            setNouvelleReservation(prev => ({ ...prev, telephone_client: limitedValue }));
        } else {
            // Pour les autres pays, utiliser juste le code pays + numéro saisi
            // Ne pas ajouter de "01" automatique
            setNouvelleReservation(prev => ({ ...prev, telephone_client: numericValue }));
        }
    };

    // Ouvrir le modal de réservation
    const handleOpenModal = (date) => {
        if (date) {
            setSelectedDateInfo({
                check_in: date,
                check_out: ''
            });
            // Pré-remplir la date de début
            setNouvelleReservation(prev => ({
                ...prev,
                date_debut: date
            }));
        }
        setShowBookingForm(true);
    };

    // Fermer le modal
    const handleCloseModal = () => {
        setShowBookingForm(false);
        setSelectedDateInfo(null);
        // Réinitialiser le formulaire
        setNouvelleReservation({
            nom_client: '',
            prenom_client: '',
            telephone_client: '',
            email_client: '',
            date_debut: '',
            date_fin: '',
            personnes: 1,
        });
    };

    const handleCreateBooking = async (e) => {
        e.preventDefault();
        showAlert('');

        const { nom_client, prenom_client, telephone_client, email_client, date_debut, date_fin, personnes } = nouvelleReservation;

        if (!nom_client || !prenom_client || !telephone_client || !date_debut || !date_fin) {
            handleCloseModal();
            showAlert('Veuillez remplir tous les champs obligatoires', "danger");
            return;
        }

        if (new Date(date_debut) >= new Date(date_fin)) {
            handleCloseModal();
            showAlert('La date de départ doit être après la date d\'arrivée', "danger");
            return;
        }

        // Vérifier la disponibilité d'une chambre
        const availableRoom = findAvailableRoom(date_debut, date_fin);
        if (!availableRoom) {
            handleCloseModal();
            showAlert('Aucune chambre disponible pour ces dates', "danger");
            return;
        }

        // Correspond exactement à ce qu'attend CreationReservation
        const bookingData = {
            nom_client,
            prenom_client,
            telephone_client,
            email_client: email_client || '',
            // date_debut,
            // date_fin,
            personnes: parseInt(personnes) || 1,
            chambre_id: availableRoom.id,
        };

        bookingData.date_debut = new Date(date_debut).toISOString();
        bookingData.date_fin = new Date(date_fin).toISOString();

        await createBooking(bookingData);
        handleCloseModal();
        // if (result.success) {
        //     setShowBookingForm(false);
        //     setSelectedDateInfo(null);
        //     await fetchBookings();  // Recharger les données
        //     await fetchRooms();     // Recharger les chambres
        // }
    };

    // const handleExtendBooking = async () => {
    //     if (!selectedBooking) {
    //         showAlert('Aucune réservation sélectionnée', 'danger');
    //         return;
    //     }

    //     if (!newCheckIn || !newCheckOut) {
    //         showAlert('Veuillez remplir toutes les dates', 'danger');
    //         return;
    //     }

    //     if (new Date(newCheckIn) >= new Date(newCheckOut)) {
    //         showAlert('La date de départ doit être après la date d\'arrivée', 'danger');
    //         return;
    //     }

    //     await updateBooking(selectedBooking.id, {
    //         date_debut: newCheckIn,
    //         date_fin: newCheckOut
    //     });
    // };

    // const handleCancelBooking = async (bookingId) => {
    //     if (window.confirm('Voulez-vous vraiment annuler cette réservation ?')) {
    //         await cancelBooking(bookingId, 'Annulation par le client');
    //         await fetchBookings();
    //     }
    // };

    // ============================================
    // RENDU
    // ============================================

    if (loading && bookings.length === 0) {
        return (
            <div id="wrapper">
                <Sidebar />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="text-center p-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden"></span>
                        </div>
                        <p className="mt-3"></p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>


                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <FaCalendarAlt size={25} className='mr-2' />Calendrier des réservations
                                </div>
                            </h2>
                            <small>Gestion des réservations des chambres </small>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        Calendrier
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {/* Alerte */}
                    {alert.message && (
                        <div className={`m-3 alert alert-${alert.type} row justify-content-between position-relative`}>
                            <div dangerouslySetInnerHTML={{ __html: alert.message }} />
                            <span
                                onClick={fermerNotif}
                                style={{
                                    position: 'absolute',
                                    top: '0px',
                                    right: '10px',
                                    cursor: 'pointer'
                                }}
                            >
                                <i className='fa fa-close'></i>
                            </span>
                        </div>
                    )}

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="calendar-container">

                            {/* {bookingError && (
                                <div className="error-banner warning-banner">
                                    {bookingError}
                                    <button className="error-close" onClick={() => setBookingError('')}>✖</button>
                                </div>
                            )} */}

                            <div className="main-layout">
                                <div className="calendar-column">
                                    <div className="fullcalendar-wrapper">
                                        <FullCalendar
                                            plugins={[dayGridPlugin, interactionPlugin]}
                                            initialView="dayGridMonth"
                                            locale={frLocale}
                                            headerToolbar={{
                                                left: 'prev next today',
                                                center: 'title',
                                                right: 'customAddButton'
                                            }}
                                            customButtons={{
                                                customAddButton: {
                                                    text: ' Nouvelle réservation',
                                                    click: () => handleOpenModal()
                                                }
                                            }}
                                            events={calendarEvents}
                                            eventContent={renderEventContent}
                                            dateClick={handleDateSelect}
                                            height="auto"
                                            buttonText={{
                                                today: "Aujourd'hui",
                                                month: 'Mois'
                                            }}
                                            eventDisplay="block"
                                            displayEventTime={false}
                                            eventTimeFormat={{
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                meridiem: false
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="bookings-column">
                                    <div className="bookings-panel">
                                        <div className="bookings-panel-header">
                                            <h3>
                                                {selectedDate
                                                    ? ` Réservations du ${formatDate(selectedDate)}`
                                                    : ' Réservations'
                                                }
                                            </h3>
                                        </div>

                                        <div className="bookings-list-scroll">
                                            {getFilteredBookings().length === 0 ? (
                                                <>
                                                    <div className="booking-toolbar">
                                                        <div className="me-2">
                                                            
                                                        </div>

                                                        <div className="row justify-content-center align-items-center">
                                                            <input
                                                                type="text"
                                                                placeholder="Rechercher..."
                                                                className="form-control mr-2"
                                                                style={{ maxWidth: "200px", width: "100%" }}
                                                                value={searchTerm}
                                                                onChange={(e) => {
                                                                    setSearchTerm(e.target.value);
                                                                    setCurrentPage(1);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="booking-placeholder">
                                                        <p>
                                                            {selectedDate
                                                                ? ' Aucune réservation pour cette date'
                                                                : ' Cliquez sur une date pour voir les réservations'
                                                            }
                                                        </p>
                                                        <p className="hint">
                                                            {selectedDate
                                                                ? 'Cliquez sur "Nouvelle réservation" pour en créer une'
                                                                : ''
                                                            }
                                                        </p>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="booking-list">
                                                    <div className="booking-toolbar">
                                                        <div className="me-2">
                                                            <select
                                                                value={itemsPerPage}
                                                                onChange={(e) => {
                                                                    setItemsPerPage(parseInt(e.target.value));
                                                                    setCurrentPage(1);
                                                                }}
                                                                className="form-select bg-default p-1"
                                                                style={{
                                                                    width: "auto",
                                                                    border: "1px black solid",
                                                                    borderRadius: "5px",
                                                                    padding: "5px 10px"
                                                                }}
                                                            >
                                                                <option value={2}>2</option>
                                                                <option value={5}>5</option>
                                                                <option value={10}>10</option>
                                                            </select>
                                                        </div>

                                                        <div className="row justify-content-center align-items-center">
                                                            <input
                                                                type="text"
                                                                placeholder="Rechercher..."
                                                                className="form-control mr-2"
                                                                style={{ maxWidth: "200px", width: "100%" }}
                                                                value={searchTerm}
                                                                onChange={(e) => {
                                                                    setSearchTerm(e.target.value);
                                                                    setCurrentPage(1);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>

                                                    {getPaginatedBookings().map((booking) => {
                                                        const status = getStatusBadge(booking.statut);
                                                        const showModify = booking.statut === 'reserver' || booking.statut === 'encours';
                                                        const showCancel = booking.statut === 'reserver';

                                                        return (
                                                            <div
                                                                key={booking.id}
                                                                className="booking-item"
                                                            >
                                                                <div className="booking-header">
                                                                    <span className="booking-room">
                                                                        {booking.chambre?.nom || 'Chambre'}
                                                                        ({booking.chambre?.reference || 'N/A'})
                                                                    </span>
                                                                    <span>
                                                                        {booking.prenom_client} {booking.nom_client}
                                                                    </span>
                                                                    <span className={`status-badge ${status.class}`}>
                                                                        {status.label}
                                                                    </span>
                                                                </div>
                                                                <div className="booking-header" style={{ fontSize: '0.85rem', color: '#666' }}>
                                                                    <span>
                                                                        {formatDate(booking.date_debut)} → {formatDate(booking.date_fin)}
                                                                    </span>
                                                                    <span>{booking.personnes || 1} pers.</span>
                                                                    <span>{booking.telephone_client}</span>
                                                                    <span>{booking.reference}</span>
                                                                </div>
                                                                <div className="booking-actions">
                                                                    {showModify && (
                                                                        <button
                                                                            className="btn-extend"
                                                                            onClick={() => handleOpenUpdateModal(booking)}
                                                                        >
                                                                            <FaEdit className="mr-2" style={{ color: "blue" }} size={14} />
                                                                            Modifier la réservation
                                                                        </button>
                                                                    )}
                                                                    {showCancel && (
                                                                        <button
                                                                            className="btn-cancel"
                                                                            onClick={() => handleShowDeleteModal(booking)}
                                                                        >
                                                                            <FaTimes className="mr-2" style={{ color: "red" }} size={14} />
                                                                            Annuler la réservation
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}

                                                    {getTotalPages() > 1 && (
                                                        <div className="booking-pagination">
                                                            <button
                                                                className="pagination-btn"
                                                                onClick={() => setCurrentPage(currentPage - 1)}
                                                                disabled={currentPage === 1}
                                                            >
                                                                <FaArrowLeft />
                                                            </button>
                                                            <span className="pagination-info">
                                                                Page {currentPage} / {getTotalPages()}
                                                            </span>
                                                            <button
                                                                className="pagination-btn"
                                                                onClick={() => setCurrentPage(currentPage + 1)}
                                                                disabled={currentPage === getTotalPages()}
                                                            >
                                                                <FaArrowRight />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            </div>


                            <Modal show={showBookingForm} onHide={handleCloseModal}>
                                <Modal.Header>
                                    <Modal.Title>Nouvelle réservation</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Form onSubmit={handleCreateBooking}>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group controlId="formNom">
                                                    <Form.Label>Nom <span style={{ color: 'red' }}>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="nom_client"
                                                        placeholder="Entrez le nom"
                                                        value={nouvelleReservation.nom_client}
                                                        onChange={handleChange}
                                                        required
                                                        style={{
                                                            borderRadius: '8px'
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="formPrenom">
                                                    <Form.Label>Prénom <span style={{ color: 'red' }}>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="prenom_client"
                                                        placeholder="Entrez le prénom"
                                                        value={nouvelleReservation.prenom_client}
                                                        onChange={handleChange}
                                                        required
                                                        style={{
                                                            borderRadius: '8px'
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col md={6}>
                                                <Form.Group controlId="formTelephone">
                                                    <Form.Label>Téléphone <span style={{ color: 'red' }}>*</span></Form.Label>
                                                    <PhoneInput
                                                        name="telephone_client"
                                                        value={nouvelleReservation.telephone_client}
                                                        country="bj"
                                                        onChange={(value, country) => handlePhoneChange(value, country)}
                                                        onKeyDown={(e) => {
                                                            const numericValue = nouvelleReservation.telephone_client.replace(/\D/g, '');
                                                            // Vérifier si c'est le Bénin
                                                            if (numericValue.startsWith('229')) {
                                                                // Empêcher la suppression du préfixe 22901
                                                                if (e.key === 'Backspace' || e.key === 'Delete') {
                                                                    if (numericValue.length <= 5) { // 22901 = 5 chiffres
                                                                        e.preventDefault();
                                                                    }
                                                                }
                                                                // Empêcher d'ajouter plus de 13 chiffres
                                                                else if (numericValue.length >= 13 &&
                                                                    !['ArrowLeft', 'ArrowRight', 'Tab'].includes(e.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }
                                                        }}
                                                        required
                                                        placeholder=""
                                                        inputStyle={{
                                                            width: "100%",
                                                            height: "35px",
                                                            fontSize: "12px",
                                                            paddingLeft: "55px"
                                                        }}
                                                        containerStyle={{ width: "100%" }}
                                                        inputProps={{
                                                            name: "telephone_client",
                                                            required: true,
                                                        }}
                                                        dropdownStyle={{
                                                            maxHeight: "200px",
                                                            overflowY: "auto",
                                                            zIndex: 1050,
                                                        }}
                                                        onCountryChange={(country) => {
                                                            if (country.dialCode === "229") {
                                                                // Quand on revient au Bénin, forcer le format 22901
                                                                const currentNumeric = nouvelleReservation.telephone_client.replace(/\D/g, '');
                                                                if (!currentNumeric.startsWith("22901")) {
                                                                    setNouvelleReservation(prev => ({
                                                                        ...prev,
                                                                        telephone_client: '22901' + currentNumeric.replace(/^229/, '').replace(/^0?/, '').slice(0, 8)
                                                                    }));
                                                                }
                                                            } else {
                                                                // Pour les autres pays, enlever tout préfixe spécifique
                                                                const currentNumeric = nouvelleReservation.telephone_client.replace(/\D/g, '');
                                                                setNouvelleReservation(prev => ({
                                                                    ...prev,
                                                                    telephone_client: currentNumeric.replace(/^22901/, '').replace(/^229/, '')
                                                                }));
                                                            }
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="formEmail">
                                                    <Form.Label>Email (optionnel)</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="email_client"
                                                        placeholder="Entrez l'email"
                                                        value={nouvelleReservation.email_client}
                                                        onChange={handleChange}
                                                        style={{
                                                            borderRadius: '8px'
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col md={6}>
                                                <Form.Group controlId="formDateDebut">
                                                    <Form.Label>Date d'arrivée <span style={{ color: 'red' }}>*</span></Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="date_debut"
                                                        value={nouvelleReservation.date_debut}
                                                        onChange={handleChange}
                                                        min={new Date().toISOString().split('T')[0]}
                                                        required
                                                        style={{
                                                            borderRadius: '8px'
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group controlId="formDateFin">
                                                    <Form.Label>Date de départ <span style={{ color: 'red' }}>*</span></Form.Label>
                                                    <Form.Control
                                                        type="date"
                                                        name="date_fin"
                                                        value={nouvelleReservation.date_fin}
                                                        onChange={handleChange}
                                                        min={nouvelleReservation.date_debut || new Date().toISOString().split('T')[0]}
                                                        required
                                                        style={{
                                                            borderRadius: '8px'
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row className="mt-3">
                                            <Col md={6}>
                                                <Form.Group controlId="formPersonnes">
                                                    <Form.Label>Nombre de personnes</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        name="personnes"
                                                        min="1"
                                                        max="6"
                                                        value={nouvelleReservation.personnes}
                                                        onChange={handleChange}
                                                        style={{
                                                            borderRadius: '8px'
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseModal}>
                                        <strong>Fermer</strong>
                                    </Button>
                                    <Button variant="success" onClick={handleCreateBooking}>
                                        <strong>{loading ? 'Création...' : 'Réserver'}</strong>
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* Modal de Modification de réservation */}
                            <Modal show={showExtensionModal} onHide={() => setShowExtensionModal(false)} >
                                <Modal.Header >
                                    <Modal.Title>
                                        <FaEdit className="mr-2" />
                                        Modifier la réservation
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <div className="extension-info">
                                        <p><strong>Client:</strong> {selectedBooking?.prenom_client} {selectedBooking?.nom_client}</p>
                                        <p><strong>Chambre:</strong> {selectedBooking?.chambre?.nom || ''}</p>
                                        <p><strong>Séjour actuel:</strong> {formatDate(selectedBooking?.date_debut)} → {formatDate(selectedBooking?.date_fin)}</p>
                                        <p><strong>Référence:</strong> {selectedBooking?.reference}</p>
                                    </div>

                                    <hr className="my-3" />

                                    <div className="form-row">
                                        <div className="form-group">
                                            <label>Nouvelle date d'arrivée <span style={{ color: 'red' }}>*</span></label>
                                            <input
                                                type="date"
                                                name="date_debut"
                                                required
                                                value={selectedBooking?.date_debut.split('T')[0]}
                                                // min={selectedBooking?.date_debut.split('T')[0]}
                                                className="form-input"
                                                onChange={(e) =>
                                                    setSelectedBooking({ ...selectedBooking, date_debut: e.target.value })
                                                }
                                                disabled={selectedBooking?.statut === 'encours'}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Nouvelle date de départ <span style={{ color: 'red' }}>*</span></label>
                                            <input
                                                type="date"
                                                name="date_fin"
                                                required
                                                value={selectedBooking?.date_fin.split('T')[0]}
                                                min={selectedBooking?.date_debut.split('T')[0]}
                                                className="form-input"
                                                onChange={(e) =>
                                                    setSelectedBooking({ ...selectedBooking, date_fin: e.target.value })
                                                }
                                            />
                                        </div>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary"
                                        onClick={() => setShowExtensionModal(false)}
                                    >
                                        <strong>Fermer</strong>
                                    </Button>
                                    <Button variant="success" onClick={updateBooking} disabled={loading}>
                                        <strong>Modifier</strong>
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* Modal de confirmation de suppression */}
                            <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
                                <Modal.Header>
                                    <Modal.Title>Confirmer l'annulation</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    Êtes-vous sûr de vouloir annuler cette réservation
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCloseDeleteModal}>
                                        <strong>Fermer</strong>
                                    </Button>
                                    <Button variant="success" onClick={handleAnnulerBooking}>
                                        <strong>Annuler</strong>
                                    </Button>
                                </Modal.Footer>
                            </Modal>



                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Calendrier;